var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsSlider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#settings-slider_svg__clip0_1710_934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.358 2.32h1.22c.12 1.05.99 1.86 2.07 1.86 1.08 0 1.95-.82 2.07-1.86h9.8c.19 0 .35-.16.35-.35 0-.19-.16-.35-.35-.35h-9.83A2.08 2.08 0 003.658 0c-.99 0-1.83.69-2.04 1.62H.358c-.19 0-.35.16-.35.35 0 .19.16.35.35.35zM15.5 6.68h-2.49a2.084 2.084 0 00-4.16 0H.35c-.19 0-.35.16-.35.35 0 .19.16.35.35.35h8.58c.25.87 1.05 1.51 2 1.51s1.75-.64 2-1.51h2.57c.19 0 .35-.16.35-.35 0-.19-.16-.35-.35-.35zM15.5 11.58H6.81a2.086 2.086 0 00-2.06-1.74c-1.04 0-1.89.75-2.06 1.74H.35c-.19 0-.35.16-.35.35 0 .19.16.35.35.35H2.7c.17.99 1.02 1.74 2.06 1.74s1.89-.75 2.06-1.74h8.69c.19 0 .35-.16.35-.35 0-.19-.16-.35-.35-.35h-.01z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "settings-slider_svg__clip0_1710_934"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15.87v14.02H0z"
  })))));
}
export default SvgSettingsSlider;